import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Instagram, Mail, MapPin } from "lucide-react";
import Reveal from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const IG_URL = "https://www.instagram.com/miguelfaria.photo/";

const PROJECT_TYPES = ["Evento Desportivo", "Retrato", "Licenciamento", "Outro"];

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", project_type: "Evento Desportivo", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Preenche todos os campos.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Mensagem enviada. Em breve dou notícias.");
      setForm({ name: "", email: "", project_type: "Evento Desportivo", message: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Erro ao enviar. Tenta novamente.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contacto"
      className="bg-black py-24 md:py-32 border-t border-white/10"
      data-testid="contact-section"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-red" />
              <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">07 — Contacto</span>
            </div>
            <h2 className="font-heading text-white text-6xl md:text-7xl uppercase leading-[0.9] mb-8" data-testid="contact-title">
              Vamos<br />Trabalhar.
            </h2>
            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-md">
              Tens um evento, uma sessão ou um projeto editorial? Conta-me o que precisas. Respondo em 24h.
            </p>
            <div className="space-y-5">
              <a
                href={IG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-[#c0392b] transition-colors"
                data-testid="contact-instagram-link"
              >
                <Instagram size={20} />
                <span className="font-heading tracking-[0.2em] uppercase text-sm">@miguelfaria.photo</span>
              </a>
              <a
                href="mailto:geral@miguelfaria.photo"
                className="flex items-center gap-3 text-white hover:text-[#c0392b] transition-colors"
                data-testid="contact-email-link"
              >
                <Mail size={20} />
                <span className="font-heading tracking-[0.2em] uppercase text-sm">geral@miguelfaria.photo</span>
              </a>
              <div className="flex items-center gap-3 text-white/80">
                <MapPin size={20} />
                <span className="font-heading tracking-[0.2em] uppercase text-sm">Portugal — Internacional</span>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={150}>
            <form onSubmit={submit} className="space-y-6 border border-white/15 p-8 md:p-10" data-testid="contact-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="label-uppercase" htmlFor="name">Nome</label>
                  <input
                    id="name"
                    type="text"
                    value={form.name}
                    onChange={update("name")}
                    className="field"
                    placeholder="Nome completo"
                    data-testid="contact-input-name"
                  />
                </div>
                <div>
                  <label className="label-uppercase" htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={update("email")}
                    className="field"
                    placeholder="email@dominio.pt"
                    data-testid="contact-input-email"
                  />
                </div>
              </div>

              <div>
                <label className="label-uppercase" htmlFor="project_type">Tipo de Projeto</label>
                <select
                  id="project_type"
                  value={form.project_type}
                  onChange={update("project_type")}
                  className="field"
                  data-testid="contact-input-project-type"
                >
                  {PROJECT_TYPES.map((t) => (
                    <option key={t} value={t} className="bg-black text-white">
                      {t}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="label-uppercase" htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  rows={6}
                  value={form.message}
                  onChange={update("message")}
                  className="field resize-none"
                  placeholder="Conta-me o que precisas, datas, local..."
                  data-testid="contact-input-message"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="cta-primary disabled:opacity-50"
                data-testid="contact-submit"
              >
                {loading ? "A Enviar…" : "Enviar Mensagem"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
